import React, { Component } from 'react';
import config from '../../config';
import $, { type } from 'jquery';
import moment from "moment";
import { DISPATCH_ID, SERVICE_RESPONSE, Modules } from "../../libs/utils/Const";
import { connect } from "react-redux";
import {
    renderTableProductTree,
    renderTableProductionOrder,
    renderTableGoodsReceiptProd,
    renderTableGoodsIssue,
    renderTableProvConfAssistant,
    renderTableRscMasterData,
    renderTableRscCapacity,
} from '../TablesDocuments';
import {
    renderDataTableActions,
    ContinueModal,
    NewDocCreateModal,
} from '../../components';
import {
    ProductionOrder,
    ProductTree,
    InventoryGenExits,
    InventoryGenExitsLine,
    InventoryGenEntries,
    InventoryGenEntriesLine,
    ProvConfAsisstant,
    ProductionLine,
    ResourceModel,
} from '../../components/NewOrder';
import '../../css/responsive.css';
import '../../css/dataTables.css';
import ApiClient from '../../libs/apiClient';
const CryptoJS = require("crypto-js");
const apiClient = new ApiClient();
const models = {
    "productTree": new ProductTree(),
    "productionOrder": new ProductionOrder(),
    "goodsIssue": new InventoryGenExits(),
    "goodsReceiptProd": new InventoryGenEntries(),
    "provConfAssistant": new ProvConfAsisstant(),
    "rscMasterData": new ResourceModel(),
};

const selectDocValues = [
    { Value: 'OPOR', Tittle: 'Orden de compra' },
    { Value: 'OPQT', Tittle: 'Oferta de compra' },
    { Value: 'OPRQ', Tittle: 'Solicitud de compra' },
    { Value: 'OWOR', Tittle: 'Orden de fabricación' }
];
class NewDocTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newOrderModel: null,
            itemsDashboard: [],
            writeAccess: false,
            docNumSearch: '',
            checkboxDataTables: (new Map()),
            documentModalAction: '',
            Continue: false,
            showDocumentModal: false,
            listPrice: [],
            wareHouses: [],
            listProjects: [],
            comments: '',
            InventoryGenExitsModel: new InventoryGenExits(),
            editMode: false,
            copyTo: '',
            viewCreate: '',
            tableSearch: 'OPOR',
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
        };

        this.table = null;
        this.documentCreateModal = null;
    }

    componentDidMount = () => {
        const { view } = this.props;
        this.createDataTable();
        if (view !== "rscMasterData") { this.setDateToday(); }
        this.searchPermissions();
    }

    setEditMode = value => {
        this.setState({
            editMode: value
        })
    }

    componentDidUpdate = () => {
        if (this.table === null) {
            this.createDataTable();
        }
    }

    shouldComponentUpdate = async (nextProps) => {
        if (this.props.data !== nextProps.data) {
            this.table.destroy();
            this.table = null;
        }

        return true;
    }

    createDataTable = () => {
        this.table = $('#dataTableTimbra').DataTable({
            "dom": '<"toolbar">frtip',
            "pagingType": "full_numbers",
            "columnDefs": [{
                "targets": 0,
                "orderable": false
            }],
            responsive: true,
        });

        this.getTableInfoResult();
        this.changePaging();
    };

    getTableInfoResult = () => {
        const info = this.table.page.info();
        let num = 0;

        try {
            if (info && info.recordsDisplay !== 0) {
                num = 1;
            }
        } catch (error) {
            console.log(error)
        }

        $('#tableInfo').text((info.start + num) + " - " + info.end + " de " + info.recordsTotal);
        $('.dataTables_empty').text("No hay resultados por mostrar");
    }

    changePaging = () => {
        const value = $('#changePaginateSelect').val();
        this.table.page.len(value).draw();
        this.getTableInfoResult();
    }

    setDateToday = () => {
        document.getElementById("startDate").value = moment(new Date()).format('YYYY-MM-DD');
        document.getElementById("endingDate").value = moment(new Date()).format('YYYY-MM-DD');
    }

    searchPermissions = () => {
        const { view } = this.props;
        let itemsDashboard = JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard'));
        const bytes = CryptoJS.AES.decrypt(itemsDashboard, 'exchange');
        itemsDashboard = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        let writeAccess = false;
        for (const key in itemsDashboard) {
            if (Object.hasOwnProperty.call(itemsDashboard, key)) {
                const module = itemsDashboard[key];
                if (key === view) {
                    writeAccess = module.Wr
                }
            }
        }

        this.setState({ itemsDashboard, writeAccess });
    }

    refreshContinue = (Continue) => {
        this.setState({ Continue });
    };

    searchByDocNum = (event) => {
        this.setState({ docNumSearch: event.nativeEvent.target.value });
    };

    searchByTable = async (event) => {
        await this.setState({ tableSearch: event.nativeEvent.target.value });
        await this.searchDocuments()
    };

    searchDocuments = (table = '', action = '') => {
        const { search, view } = this.props;
        const { docNumSearch, tableSearch } = this.state;
        let date = {}

        if (table !== '' && action === 'close') this.setState({ tableSearch: table });

        if (view !== "rscMasterData") {
            date = {
                dateInit: moment(document.getElementById("startDate").value).format('YYYYMMDD'),
                dateFinal: moment(document.getElementById("endingDate").value).format('YYYYMMDD'),
                docNumSearch: docNumSearch === '' || !docNumSearch ? '--' : docNumSearch,
                tableSearch: table || tableSearch,
            };
        }

        search(date);

        setTimeout(() => {
            this.setState({ docNumSearch: '' });
        }, 250);
    }

    renderTableActions = () => {
        const { view } = this.props;
        const { writeAccess } = this.state;
        return renderDataTableActions(
            this.searchInTable, () => this.createDocument(), null,
            view, null, null,
            null, null, null,
            null, null, null,
            null, null, writeAccess,
            null, null, null,
            null, null, null,
            null, null, null,
        );
    }

    searchInTable = key => {
        const value = key.target.value;
        const table = $('#dataTableTimbra').DataTable();
        table.search(value);
        table.draw();
        this.getTableInfoResult();
    }

    renderTable = () => {
        const { view, headers, data } = this.props;
        const { checkboxDataTables } = this.state;
        const configStorage = JSON.parse(localStorage.getItem(view + 'configHeader'));
        const checkbox = {
            data: checkboxDataTables,
            selectOne: this.toggleDocumentSelected,
            selectAll: this.toggleDocumentSelectedAll,
        };
        let table = '', newHeaders = [];

        if (!configStorage) {
            localStorage.setItem(view + 'configHeader', JSON.stringify(headers));
            newHeaders = headers;
        } else {
            newHeaders = configStorage;
        }

        switch (view) {
            case "productTree":
                table = renderTableProductTree(newHeaders, data, checkbox, this.OpenDocumentDetails);
                break;
            case "productionOrder":
                table = renderTableProductionOrder(newHeaders, data, checkbox, this.OpenDocumentDetails);
                break;
            case "goodsReceiptProd":
                table = renderTableGoodsReceiptProd(newHeaders, data, checkbox, this.OpenDocumentDetails);
                break;
            case "goodsIssue":
                table = renderTableGoodsIssue(newHeaders, data, checkbox, this.OpenDocumentDetails);
                break;
            case "provConfAssistant":
                table = renderTableProvConfAssistant(newHeaders, data, checkbox);
                break;
            case "rscMasterData":
                table = renderTableRscMasterData(newHeaders, data, checkbox, this.OpenDocumentDetails);
                break;
            case "rscCapacity":
                table = renderTableRscCapacity(newHeaders, data, checkbox, this.OpenDocumentDetails);
                break;
            default:
                table = "";
        }

        return table;
    }

    toggleDocumentSelected = (id) => {
        this.setState(state => {
            const checkboxDataTables = new Map(state.checkboxDataTables);
            checkboxDataTables.set(id, !checkboxDataTables.get(id));
            return { checkboxDataTables };
        });
    };

    toggleDocumentSelectedAll = (action) => {
        const { data } = this.props;
        const newCheckbox = (new Map());

        for (let index = 0; index < data.length; index++) {
            newCheckbox.set(index, action)
        }

        this.setState({ checkboxDataTables: newCheckbox });
    };

    setOrderProduct = data => {
        let newOrderModel = new ProductionOrder();
        newOrderModel.ProductionOrderType = data.Type
        newOrderModel.ProductionOrderStatus = data.Status
        newOrderModel.ItemNo = data.ItemCode
        newOrderModel.ItemName = data.ItemName
        newOrderModel.PlannedQuantity = Number(data.PlannedQty).toFixed(2)
        newOrderModel.Warehouse = data.Warehouse
        newOrderModel.PostingDate = moment(data.PostDate).format('YYYY-MM-DD')
        newOrderModel.StartDate = moment(data.StartDate).format('YYYY-MM-DD')
        newOrderModel.DueDate = moment(data.DueDate).format('YYYY-MM-DD')
        newOrderModel.UserSelected = {}
        newOrderModel.UserSelected.U_NAME = data.U_NAME
        newOrderModel.UserSignature = data.UserSign
        newOrderModel.ProductionOrderOrigin = data.OriginType
        newOrderModel.Client = {}
        newOrderModel.Client.CardName = data.CardName
        newOrderModel.CustomerCode = data.CardCode
        newOrderModel.Project = data.Project
        newOrderModel.JournalRemarks = data.JrnlMemo
        newOrderModel.CompletedQuantity = Number(data.CmpltQty).toFixed(2)
        newOrderModel.RejectedQuantity = Number(data.RjctQty).toFixed(2)
        newOrderModel.ClosingDate = moment(data.CloseDate).format('YYYY-MM-DD')
        newOrderModel.Remarks = data.Comments
        newOrderModel.PickRmrk = data.PickRmrk
        //CALCULAR VENCIDO PARA RESUMEN DE ORDEN
        const initDate = data.DueDate ? moment(data.DueDate) : moment()
        const endDate = data.CloseDate ? moment(data.CloseDate) : moment()
        const diferenciaEnDias = (data.DueDate && data.CloseDate) ? endDate.diff(initDate, 'days') : 0
        newOrderModel.Vencido = diferenciaEnDias


        let lines = []
        for (let index = 0; index < data.ProductionOrderLines.length; index++) {
            const item = data.ProductionOrderLines[index];
            const auxItem = {
                ItemType: item.ItemType,
                ItemNo: item.ItemCode,
                ItemName: item.ItemName,
                BaseQuantity: item.BaseQty,
                BaseQuantityCopy: item.BaseQty,
                PlannedQuantity: item.PlannedQty,
                IssuedQuantity: item.IssuedQty,
                Warehouse: item.wareHouse,
                IssueMethod: item.IssueType,
            }
            lines.push(auxItem)

        }
        newOrderModel.ProductionOrderLines = lines
        return newOrderModel
    }


    setProducTreeModel = data => {
        let newOrderModel = new ProductTree();
        newOrderModel.TreeCode = data.Code
        newOrderModel.Desc = data.ItemName
        newOrderModel.TreeType = data.TreeType
        newOrderModel.Quantity = data.Qauntity
        newOrderModel.Project = data.Project
        newOrderModel.PriceList = data.PriceList
        newOrderModel.Warehouse = data.ToWH
        newOrderModel.InvntItem = data.InvntItem
        newOrderModel.SellItem = data.SellItem
        newOrderModel.PrchseItem = data.PrchseItem

        const prodTreeLines = []
        for (let index = 0; index < data.ProductTreeLines.length; index++) {
            const item = data.ProductTreeLines[index];
            const auxItem = {
                ItemCode: item.Code,
                Quantity: item.Quantity,
                Warehouse: item.Warehouse,
                Price: item.Price,
                Currency: item.Currency,
                IssueMethod: item.IssueMthd,
                InventoryUOM: item.Uom,
                Comment: item.Comment,
                ParentItem: item.Father,
                PriceList: item.PriceList,
                ItemType: item.Type,
                ItemName: item.ItemName,
            }
            prodTreeLines.push(auxItem)

        }
        newOrderModel.ProductTreeLines = prodTreeLines || []
        return newOrderModel
    }

    // openDocumentDetails = async (model) => {
    //     const { enableSpinner, notificationReducer: { showAlert }, view } = this.props
    //     enableSpinner(true)
    //     let response = null;
    //     if (view === 'productionOrder') {
    //         response = await apiClient.getOrderProdDetails(model.DocEntry)
    //     } else if (view === 'productTree') {
    //         response = await apiClient.getKitDetails(model.TreeCode || model.Code)
    //     }
    //     enableSpinner(false)
    //     if (response.status === SERVICE_RESPONSE.SUCCESS) {

    //         let newOrderModel = models[view]

    //         enableSpinner(true)
    //         let wareHouses = await apiClient.getWhsCodes();
    //         let listPrice = await apiClient.getPriceList();
    //         enableSpinner(false)
    //         if (view === 'productionOrder') {
    //             newOrderModel = this.setOrderProduct(response.data)
    //         } else if (view === 'productTree') {
    //             newOrderModel = this.setProducTreeModel(response.data)
    //         }
    //         newOrderModel.OriginDocumentCreate = view
    //         await this.setState({
    //             listPrice: listPrice?.data ?? [],
    //             wareHouses: wareHouses?.data ?? [],
    //             showDocumentModal: true,
    //             documentModalAction: 2,
    //             newOrderModel,
    //         });
    //         this.documentCreateModal.restartTabs();
    //         $('#DocumentCreateModal').modal({ backdrop: 'static', keyboard: false }, 'show');
    //     } else {
    //         showAlert({ type: 'error', message: response.message || 'LISTA NO DISPONIBLE' })
    //     }
    // }
    FillModelProductionOrder = async (header, lines, relatedDocs) => {
        if (header === null) return new ProductionOrder();
        const { view } = this.props;
        let newOrderModel = new ProductionOrder();
        await this.SetSeriesToModel(newOrderModel)
        const serieDoc = newOrderModel.SerieArray.find(serie => Number(serie?.Series ?? -1) === Number(header?.Series ?? -2) && serie.ObjectCode === newOrderModel.docType)
        if (serieDoc) {
            newOrderModel.SerieName = serieDoc.SeriesName
            newOrderModel.NextFolio = header.DocNum
        }
        newOrderModel.RelatedDocs = relatedDocs
        newOrderModel.AbsoluteEntry = header.DocEntry
        newOrderModel.OriginDocumentCreate = view
        newOrderModel.ProductionOrderType = header.Type
        newOrderModel.ProductionOrderStatus = header.Status;
        newOrderModel.CurrentStatus = newOrderModel.ProductionOrderStatus;
        if (newOrderModel?.ProductionOrderStatus !== 'P') {
            newOrderModel.OnlyView = true;
        }
        newOrderModel.ItemNo = header.ItemCode
        newOrderModel.ItemName = header.ItemName
        newOrderModel.PlannedQuantity = Number(header.PlannedQty).toFixed(2)
        newOrderModel.Warehouse = header.Warehouse;
        newOrderModel.WhsName = header.WhsName ?? '';
        newOrderModel.PostingDate = moment(header.PostDate).format('YYYY-MM-DD')
        newOrderModel.StartDate = moment(header.StartDate).format('YYYY-MM-DD')
        newOrderModel.DueDate = moment(header.DueDate).format('YYYY-MM-DD')
        newOrderModel.UserSelected = {}
        newOrderModel.UserSelected.U_NAME = header.U_NAME
        newOrderModel.UserSignature = header.UserSign
        newOrderModel.ProductionOrderOrigin = header.OriginType
        newOrderModel.Client = {}
        newOrderModel.Client.CardName = header.CardName
        newOrderModel.CustomerCode = header.CardCode
        newOrderModel.Project = header.Project
        newOrderModel.JournalRemarks = header.JrnlMemo
        newOrderModel.CompletedQuantity = Number(header.CmpltQty).toFixed(2)
        newOrderModel.RejectedQuantity = Number(header.RjctQty).toFixed(2)
        newOrderModel.ClosingDate = moment(header.CloseDate).format('YYYY-MM-DD')
        newOrderModel.Remarks = header.Comments
        newOrderModel.PickRmrk = header.PickRmrk
        newOrderModel.Uom = header.InvntryUom ?? header?.Uom ?? '';
        newOrderModel.CostoComponenteArticuloReal = header.CostoComponenteArticuloReal > 0 ? header.CostoComponenteArticuloReal : ''
        //CALCULAR VENCIDO PARA RESUMEN DE ORDEN
        const initDate = header.DueDate ? moment(header.DueDate) : moment()
        const endDate = header.CloseDate ? moment(header.CloseDate) : moment()
        const diferenciaEnDias = (header.DueDate && header.CloseDate) ? endDate.diff(initDate, 'days') : 0
        newOrderModel.Vencido = diferenciaEnDias;

        //#region Version 1
        // const LinesToInventoryGenExits = header.LinesInventoryGenExits.filter((relatedDocLine) => Number(relatedDocLine.IssuedQty) > 0);
        // const findManualMethod = lines.find((element) => element?.IssueType === 'M');
        // newOrderModel.FlagCreateGoodIssue = header.Status === 'R' && findManualMethod !== undefined && (header.LinesInventoryGenExits.length === 0 || LinesToInventoryGenExits.length > 0) ? true : false; // Debe de ser Liberado, tener una linea en manual y que la cantidad IssuedQty > 0
        // FlagCreateGoodIssue -> Solo sale cuando tiene linea manuales (si todas son notificacion no saldrá) posterior a el sale el FlagCreateGoodsReceiptProd
        // newOrderModel.FlagCreateGoodsReceiptProd = (header.LinesInventoryGenExits && header.LinesInventoryGenExits.length > 0 && LinesToInventoryGenExits.length === 0) ? true : false;
        //#endregion Version 1

        //#region Version 2
        const isReleased = header?.Status === 'R'; // Validar si la orden está LIBERADA
        const hasManual = lines?.some(l => l.IssueType === 'M'); // Detectar si existen líneas MANUAL
        const manualPending = lines?.some(l => l.IssueType === 'M' && Number(l.PlannedQty) > Number(l.IssuedQty)); // Validar si existe al menos UNA línea manual pendiente por emitir

        // Validar si TODAS las líneas manual están completamente emitidas
        // Si no existen manuales, se considera automáticamente "completado" porque no hay nada que validar
        const manualCompleted = !hasManual || lines?.filter(l => l.IssueType === 'M')?.every(l => Number(l.IssuedQty) >= Number(l.PlannedQty));

        const inventoryGenExistsCompleted = header?.LinesInventoryGenEntries?.isFullyReceived || false;
        newOrderModel.totalReceived = Number(header?.LinesInventoryGenEntries?.totalReceived ?? 0);

        /* CREAR EMISIÓN (InventoryGenExits)
        
           Casos que cubre:
           - Todo Manual sin emitir
           - Manual parcial
           - Mixto con manual pendiente
        
           Casos donde NO aparece:
           - Todo Notificación
           - Manual completamente emitido
           - Orden no liberada
        */
        newOrderModel.FlagCreateGoodIssue = isReleased && hasManual && manualPending;

        /* CREAR RECIBO DE PRODUCCIÓN (InventoryGenEntries)
           Casos que cubre:
           - Todo Notificación
           - Todo Manual completamente emitido
           - Mixto con Manual completamente emitido
           - Aún no se copia toda la cantidad planeada
        
           Casos donde NO aparece:
           - Manual pendiente
           - Manual parcial
           - Orden no liberada
           - Ya se copio la cantidad planeada
        */

        newOrderModel.FlagCreateGoodsReceiptProd = isReleased && manualCompleted && !inventoryGenExistsCompleted;
        //#enndregion Version 2
        newOrderModel.DocEntry = header.DocEntry;
        newOrderModel.DocNum = header.DocNum;
        newOrderModel.Series = header.Series ?? "";
        newOrderModel.SerieCode = header.Series ?? "";
        //#region CUFD
        newOrderModel.U_RS_CANT = Number(header?.U_RS_CANT ?? 0);
        //#endregion CUFD

        let ProductionOrderLines = [];

        const issueType = {
            'M': 'im_Manual',
            'B': 'im_Backflush'
        }
        for (let index = 0; index < lines.length; index++) {
            const item = lines[index];
            const auxItem = new ProductionLine();
            auxItem.ItemType = item.ItemType || item.Type
            auxItem.ItemNo = item.ItemCode
            auxItem.ItemName = item.ItemName
            auxItem.BaseQuantity = item.BaseQty
            auxItem.BaseQuantityCopy = item.BaseQty
            auxItem.PlannedQuantity = item.PlannedQty
            auxItem.IssuedQuantity = item.IssuedQty
            auxItem.Warehouse = item.wareHouse
            auxItem.ProductionOrderIssueType = issueType[item.IssueType || item.IssueMthd]
            auxItem.LineNumber = item.LineNum ?? -1
            auxItem.Uom = item.InvntryUom
            auxItem.UoMCode = item.UomCode || '';
            auxItem.Available = item.Disponible;
            auxItem.isStatic = item.isStatic ?? null;
            auxItem.WhsCode = item.WhsCode ?? item.wareHouse ?? '';
            auxItem.WhsName = item.WhsName ?? '';
            auxItem.unitMsr = item.unitMsr ?? '';
            auxItem.OcrCode = item?.OcrCode ?? '';
            auxItem.OcrCode2 = item?.OcrCode2 ?? '';
            auxItem.OcrCode3 = item?.OcrCode3 ?? '';
            auxItem.OcrCode4 = item?.OcrCode4 ?? '';
            auxItem.OcrCode5 = item?.OcrCode5 ?? '';
            auxItem.OnHand = item?.OnHand ?? null;

            ProductionOrderLines.push(auxItem)

        }
        newOrderModel.ProductionOrderLines = ProductionOrderLines;

        return newOrderModel
    }

    FillModelResourceDetails = async (Header, WhsLines) => {
        let activeFrom = moment(Header.validFrom || "");
        let activeTo = moment(Header.validTo || "");
        let inactiveFrom = moment(Header.frozenFrom || "");
        let inactiveTo = moment(Header.frozenTo || "");
        let model = new ResourceModel();

        model.Code = Header.ResCode;
        model.VisCode = Header.VisResCode;
        model.CodeBar = Header.CodeBars;
        model.Name = Header.ResName;
        model.ForeignName = Header.FrgnName;
        model.Type = Header.ResType;
        model.Group = Header.ResGrpCod;
        model.UnitOfMeasure = Header.UnitOfMsr;
        model.TimePerUnits = Header.TimeResUn;
        model.UnitsPerTime = Header.NumResUnit;
        model.IssueMethod = Header.IssueMthd;
        model.Allocation = Header.ResAlloc;
        model.Active = Header.validFor;
        model.ActiveFrom = activeFrom.isValid() ? activeFrom.format("YYYY-MM-DD") : "";
        model.ActiveTo = activeTo.isValid() ? activeTo.format("YYYY-MM-DD") : "";
        model.ActiveRemarks = Header.ValidComm;
        model.Inactive = Header.frozenFor;
        model.InactiveFrom = inactiveFrom.isValid() ? inactiveFrom.format("YYYY-MM-DD") : "";
        model.InactiveTo = inactiveTo.isValid() ? inactiveTo.format("YYYY-MM-DD") : "";
        model.InactiveRemarks = Header.FrozenComm;
        model.Costs = [];
        model.Costs.push(Number(Header.StdCost1 || 0).toFixed(2));
        model.Costs.push(Number(Header.StdCost2 || 0).toFixed(2));
        model.Costs.push(Number(Header.StdCost3 || 0).toFixed(2));
        model.Costs.push(Number(Header.StdCost4 || 0).toFixed(2));
        model.Costs.push(Number(Header.StdCost5 || 0).toFixed(2));
        model.Costs.push(Number(Header.StdCost6 || 0).toFixed(2));
        model.Costs.push(Number(Header.StdCost7 || 0).toFixed(2));
        model.Costs.push(Number(Header.StdCost8 || 0).toFixed(2));
        model.Costs.push(Number(Header.StdCost9 || 0).toFixed(2));
        model.Costs.push(Number(Header.StdCost10 || 0).toFixed(2));

        return model;
    }

    FillModelProductTree = (header, lines) => {
        if (header === null) return new ProductTree();
        const { view } = this.props
        let newOrderModel = new ProductTree();
        newOrderModel.OriginDocumentCreate = view
        newOrderModel.TreeCode = header.Code
        newOrderModel.Desc = header.ItemName
        newOrderModel.TreeType = header.TreeType
        newOrderModel.Quantity = header.Qauntity
        newOrderModel.Project = header.Project
        newOrderModel.PriceList = header.PriceList
        newOrderModel.Warehouse = header.ToWH
        newOrderModel.InvntItem = header.InvntItem
        newOrderModel.SellItem = header.SellItem
        newOrderModel.PrchseItem = header.PrchseItem
        newOrderModel.PlAvgSize = header.PlAvgSize

        const prodTreeLines = []
        for (let index = 0; index < lines.length; index++) {
            const item = lines[index];
            const auxItem = {
                ItemCode: item.Code,
                Quantity: item.Quantity,
                Warehouse: item.Warehouse,
                Price: item.Price,
                Currency: item.Currency,
                IssueMethod: item.IssueMthd,
                InventoryUOM: item.InventoryUOM,
                Comment: item.Comment,
                ParentItem: item.Father,
                PriceList: item.PriceList,
                ItemType: item.Type,
                ItemName: item.ItemName,
                LineText: item.LineText,
                StdCost1: item.StdCost1,
                OcrCode: item?.OcrCode ?? '',
                OcrCode2: item?.OcrCode2 ?? '',
                OcrCode3: item?.OcrCode3 ?? '',
                OcrCode4: item?.OcrCode4 ?? '',
                OcrCode5: item?.OcrCode5 ?? '',
            }
            prodTreeLines.push(auxItem)

        }
        newOrderModel.ProductTreeLines = prodTreeLines || []
        return newOrderModel
    }
    LoadProductTreeData = async () => {
        const { enableSpinner } = this.props
        enableSpinner(true)
        let data = {
            needDimensions: Modules.CostCenter,
        }
        let wareHouses = await apiClient.getWhsCodes(data);
        let listPrice = await apiClient.getPriceList();
        enableSpinner(false)
        await this.setState({
            listPrice: listPrice?.data ?? [],
            wareHouses: wareHouses?.data ?? [],
        });
    }
    LoadProductionOrderData = async () => {
        const { enableSpinner } = this.props
        enableSpinner(true)
        let data = {
            needDimensions: Modules.CostCenter,
        }
        let wareHouses = await apiClient.getWhsCodes(data);
        let listPrice = await apiClient.getPriceList();
        let listProjects = await apiClient.getListProjects();
        enableSpinner(false)
        await this.setState({
            listPrice: listPrice?.data ?? [],
            wareHouses: wareHouses?.data ?? [],
            listProjects: listProjects?.data ?? [],
        });
    }
    LoadRequiredData = async view => {
        switch (view) {
            case 'productTree':
                await this.LoadProductTreeData()
                break;
            case 'productionOrder':
                await this.LoadProductionOrderData()
                break;
            default:
                break;
        }
    }

    OpenDocumentDetails = async (document) => {
        const { enableSpinner, notificationReducer: { showAlert }, view } = this.props
        const table = this.selectTable(view);
        const data = {
            docEntry: document.DocEntry || document.Code || document.TreeCode || document.ResCode,
            table: table.name,
            docSubType: table.docSubType,
            complement: table.complement,
            view: view,
        };

        enableSpinner(true);
        const detailsResponse = await apiClient.getProdDocumentDetails(data);
        enableSpinner(false);
        await this.LoadRequiredData(view)
        let newModel = null;
        switch (view) {
            case "goodsIssue":
                newModel = await this.FillModelInventoryGenExitsDetails(detailsResponse.data?.Header ?? null, detailsResponse.data?.Lines ?? []);
                break;
            case "productTree":
                newModel = await this.FillModelProductTree(detailsResponse.data?.Header ?? null, detailsResponse.data?.Lines ?? []);
                break;
            case "productionOrder":
                newModel = await this.FillModelProductionOrder(detailsResponse.data?.Header ?? null, detailsResponse.data?.Lines ?? [], detailsResponse.data?.RelatedDocs ?? []);
                break;
            case "goodsReceiptProd":
                newModel = await this.FillModelInventoryGenEntriesDetails(detailsResponse.data?.Header ?? null, detailsResponse.data?.Lines ?? []);
                break;
            case "rscMasterData":
                newModel = await this.FillModelResourceDetails(detailsResponse.data?.Header ?? null, detailsResponse.data?.Lines ?? []);
                break;
            default:
                break;
        }
        newModel.isEdit = true
        newModel.OriginDocumentCreate = view;
        await this.setState({
            showDocumentModal: true,
            newOrderModel: newModel,
            documentModalAction: 2,
        });

        this.documentCreateModal.restartTabs();
        $('#DocumentCreateModal').modal({ backdrop: 'static', keyboard: false }, 'show');
    }

    FillModelInventoryGenExitsDetails = async (Header, Lines) => {
        let model = new InventoryGenExits();
        if (Header !== null) {
            model.DocEntry = Header.DocEntry ?? -1;
            model.DocNum = Header.DocNum ?? '';
            model.Comments = Header.Comments ?? '';
            model.DocDate = Header.DocDate ?? '';
            model.DocStatus = Header.DocStatus ?? '';
            model.JournalMemo = Header.JrnlMemo ?? '';
            model.Reference2 = Header.Ref2 ?? '';
            model.Series = Header.Series ?? '';
            model.SerieName = Header.SeriesName ?? '';
            model.DocDueDate = Header.TaxDate ?? '';
        }

        if (Lines.length > 0) {
            for (let x = 0; x < Lines.length; x++) {
                const line = Lines[x];
                let modelLine = new InventoryGenExitsLine();
                modelLine.AccountCode = line.AcctCode ?? '';
                modelLine.BaseEntry = line.BaseEntry ?? null;
                modelLine.BaseLine = line.BaseLine ?? null;
                modelLine.BaseRef = line.BaseRef ?? '';
                modelLine.BaseType = line.BaseType ?? -1;
                modelLine.DocEntry = line.DocEntry ?? '';
                modelLine.ItemDescription = line.Dscription ?? '';
                modelLine.ItemCode = line.ItemCode ?? '';
                modelLine.LineNum = line.LineNum ?? '';
                modelLine.LineStatus = line.LineStatus ?? '';
                modelLine.LineTotal = line.LineTotal ?? 0.0;
                modelLine.OpenQty = line.OpenQty ?? 0.0;
                modelLine.Price = line.Price ?? 0.0;
                modelLine.Quantity = line.Quantity ?? 0.0;
                modelLine.WarehouseCode = line.WhsCode ?? '';
                modelLine.ItemType = line.ItemType ?? '';
                modelLine.SeriesName = line.SeriesName ?? '';
                modelLine.Series = line.Series ?? '';
                modelLine.PlannedQty = line.PlannedQty ?? '';
                modelLine.WhsCode = line.WhsCode ?? '';
                modelLine.WhsName = line.WhsName ?? '';
                modelLine.unitMsr = line.unitMsr ?? '';
                modelLine.OcrCode = line?.OcrCode ?? '';
                modelLine.OcrCode2 = line?.OcrCode2 ?? '';
                modelLine.OcrCode3 = line?.OcrCode3 ?? '';
                modelLine.OcrCode4 = line?.OcrCode4 ?? '';
                modelLine.OcrCode5 = line?.OcrCode5 ?? '';
                model.DocumentLines.push(modelLine)
            }

        }

        return model;
    }

    FillModelInventoryGenEntriesDetails = async (Header, Lines) => {
        let model = new InventoryGenEntries();
        if (Header !== null) {
            model.DocEntry = Header.DocEntry ?? -1;
            model.DocNum = Header.DocNum ?? '';
            model.Comments = Header.Comments ?? '';
            model.DocDate = Header.DocDate ?? '';
            model.DocStatus = Header.DocStatus ?? '';
            model.JournalMemo = Header.JrnlMemo ?? '';
            model.Reference2 = Header.Ref2 ?? '';
            model.Series = Header.Series ?? '';
            model.SerieName = Header.SeriesName ?? '';
            model.DocDueDate = Header.TaxDate ?? '';
        }

        if (Lines.length > 0) {
            for (let x = 0; x < Lines.length; x++) {
                const line = Lines[x];
                let modelLine = new InventoryGenEntriesLine();
                modelLine.AccountCode = line.AcctCode ?? '';
                modelLine.BaseEntry = line.BaseEntry ?? null;
                modelLine.BaseLine = line.BaseLine ?? null;
                modelLine.BaseRef = line.BaseRef ?? '';
                modelLine.BaseType = line.BaseType ?? -1;
                modelLine.DocEntry = line.DocEntry ?? '';
                modelLine.ItemDescription = line.Dscription ?? '';
                modelLine.ItemCode = line.ItemCode ?? '';
                modelLine.LineNum = line.LineNum ?? '';
                modelLine.LineStatus = line.LineStatus ?? '';
                modelLine.LineTotal = line.LineTotal ?? 0.0;
                modelLine.OpenQty = line.OpenQty ?? 0.0;
                modelLine.Price = line.Price ?? 0.0;
                modelLine.Quantity = line.Quantity ?? 0.0;
                modelLine.WarehouseCode = line.WhsCode ?? '';
                modelLine.ItemType = line.ItemType ?? '';
                modelLine.SeriesName = line.SeriesName ?? '';
                modelLine.Series = line.Series ?? '';
                modelLine.PlannedQty = line.PlannedQty ?? '';
                modelLine.TranType = line.TranType ?? '';
                modelLine.WhsCode = line.WhsCode ?? '';
                modelLine.WhsName = line.WhsName ?? '';
                modelLine.unitMsr = line.unitMsr ?? '';
                modelLine.OcrCode = line?.OcrCode ?? '';
                modelLine.OcrCode2 = line?.OcrCode2 ?? '';
                modelLine.OcrCode3 = line?.OcrCode3 ?? '';
                modelLine.OcrCode4 = line?.OcrCode4 ?? '';
                modelLine.OcrCode5 = line?.OcrCode5 ?? '';
                model.DocumentLines.push(modelLine)
            }

        }

        return model;
    }

    changePage = (page) => {
        if (this.table) {
            this.table.page(page).draw('page');
            this.getTableInfoResult();
        }
    }

    refreshModel = newOrderModel => {
        this.setState({
            newOrderModel
        })
    };

    sendModelContinue = async model => {
        $('#continueModal').modal('show');
    }

    CloseDocumentModal = async () => {
        await this.setState({ showDocumentModal: false });
        this.setEditMode(false)
    }
    createModel = (view) => {
        const orderModel = models[view]
        return orderModel
    }
    selectValidateSeries = (table, data) => {
        let series = "";

        switch (table) {
            case 'OQUT':
                series = data.U_FMB_ValidateSeriesOQUT || "";
                break;
            case 'ORDR':
                series = data.U_FMB_ValidateSeriesORDR || "";
                break;
            case 'ODLN':
                series = data.U_FMB_ValidateSeriesODLN || "";
                break;
            case 'OINV':
                series = data.U_FMB_ValidateSeriesOINV || "";
                break;
            case 'ORDN':
                series = data.U_FMB_ValidateSeriesORDN || "";
                break;
            case 'ORPD':
                series = data.U_FMB_ValidateSeriesORPD || "";
                break;
            case 'ORCT':
                series = data.U_FMB_ValidateSeriesORCT || "";
                break;
            case 'OWTR':
                series = data.U_FMB_ValidateSeriesOWTR || "";
                break;
            case 'OWTQ':
                series = data.U_FMB_ValidateSeriesOWTQ || "";
                break;
            case 'OIGN':
                series = data.U_FMB_ValidateSeriesOIGN || "";
                break;
            case 'OIGE':
                series = data.U_FMB_ValidateSeriesOIGE || "";
                break;
            case 'OINVDN':
                series = data.U_FMB_ValidateSeriesDN || "";
                break;
            case 'ORIN':
                series = data.U_FMB_ValidateSeriesORIN || "";
                break;
            case 'OPOR':
                series = data.U_FMB_ValidateSeriesOPOR || "";
                break;
            case 'OPDN':
                series = data.U_FMB_ValidateSeriesOPDN || "";
                break;

            case 'OPRQ':
                series = data.U_FMB_ValidateSeriesOPRQ || "";
                break;
            case 'OMRV':
                series = data.U_FMB_ValidateSeriesOMRV || "";
                break;
            case 'OPCH':
                series = data.U_FMB_ValidateSeriesOPCH || "";
                break;
            case 'OVPM':
                series = data.U_FMB_ValidateSeriesOVPM || "";
                break;
            case 'ORPC':
                series = data.U_FMB_ValidateSeriesORPC || "";
                break;
            case 'ODRF':
                series = "";
                break;
            case 'OWDD':
                series = "";
                break;
            case 'OCPT':
                series = "";
                break;
            case 'OIPF':
                series = data.U_FMB_ValidateSeriesOIPF || "";
                break;
            case 'OWOR':
                series = data.U_FMB_ValidateSeriesOWOR || "";
                break;
            case 'InventoryGenExits':
                series = data.U_FMB_SeriesInventoryGenExits || "";
                break;
            case 'InventoryGenEntries':
                series = data.U_FMB_SeriesInventoryGenEntries || "";
                break;
            default:
                series = "";
        }

        return { series }
    };

    SetSeriesToModel = async newOrderModel => {
        const { view, enableSpinner, notificationReducer: { showAlert } } = this.props
        let table = this.selectTable(view);
        let dataSerie = {
            docType: table.docType,
            docSubType: table.docSubType
        };
        enableSpinner(true)
        let seriesResponse = await apiClient.getSeries(dataSerie);
        enableSpinner(false);
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        let ValidateSeries = this.selectValidateSeries(table.name, user);
        let seriesUsers = ValidateSeries.series.split("|");
        let newArraySeries = [];
        seriesUsers.map(serieUser => {
            seriesResponse.data.map(serieResponse => {
                if (serieResponse.Series == serieUser && serieResponse.DocSubType === table.docSubType) {
                    newArraySeries.push(serieResponse);
                }
            })
        })
        if (newArraySeries.length === 0) {
            showAlert({ type: 'warning', timeOut: 5000, message: "El usuario no tiene serie permitida de escritura" });
            return;
        }
        let defaultName = "";
        let defaultcode = "";
        let nextNumber = "";


        for (let index = 0; index < newArraySeries.length; index++) {
            const serie = newArraySeries[index];
            if (newArraySeries.length === 1) {
                defaultName = serie.SeriesName;
                defaultcode = serie.Series;
                nextNumber = serie.NextNumber
            }
        }
        newOrderModel.SerieArray = newArraySeries;
        newOrderModel.SerieName = defaultName;
        newOrderModel.SerieCode = defaultcode;
        newOrderModel.NextFolio = nextNumber;
        newOrderModel.docType = table.docType;
        return newOrderModel
    }

    ChangeNameForSeries = (view) => {
        let nameTable = {
            'goodsIssue': 'InventoryGenExits',
            'goodsReceiptProd': 'InventoryGenEntries'
        };

        return nameTable[view];
    }


    createDocument = async (viewCopyTo = '') => {
        const { view, enableSpinner, notificationReducer: { showAlert } } = this.props
        const auxView = viewCopyTo !== '' ? viewCopyTo : view;
        //Quitar cuando se implemente logica para estas vistas
        if (auxView === 'rscCapacity') {
            await this.setState({
                showDocumentModal: true,
                documentModalAction: 1,
            });
            // this.documentCreateModal.restartTabs();
            return $('#DocumentCreateModal').modal({ backdrop: 'static', keyboard: false }, 'show');
        }
        enableSpinner(true);
        let table = this.selectTable(auxView);
        let newOrderModel = this.createModel(auxView);
        newOrderModel.OriginDocumentCreate = auxView;
        await this.LoadRequiredData(view)

        if (view !== "rscMasterData" && view !== 'provConfAssistant') {
            let dataSerie = {
                docType: table.docType,
                docSubType: table.docSubType
            };

            const seriesResponse = await apiClient.getSeries(dataSerie);
            const user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
            let tableName = table.name;

            // this its only 4 goodsReceiptProd and goodsIssue because someone made a mistake for series for this docs
            if (auxView === 'goodsReceiptProd' || auxView === 'goodsIssue') {
                tableName = this.ChangeNameForSeries(auxView);
            }
            let ValidateSeries = this.selectValidateSeries(tableName, user);
            let seriesUsers = ValidateSeries.series.split("|");
            let newArraySeries = [];

            for (const serieUser of seriesUsers) {
                for (const serieResponse of seriesResponse.data) {
                    if (
                        (view === 'productionOrder' ? String(serieResponse.Series) === String(serieUser)
                            : Number(serieResponse.Series) === Number(serieUser)
                        )
                        && serieResponse.DocSubType === table.docSubType
                    ) {
                        newArraySeries.push(serieResponse);
                    }
                }
            }

            if (newArraySeries.length === 0 && auxView !== 'productTree') {
                showAlert({ type: 'warning', timeOut: 5000, message: "El usuario no tiene serie permitida de escritura" });
                enableSpinner(false);
                return;
            }

            let defaultName = "";
            let defaultcode = "";
            let nextNumber = "";

            for (let index = 0; index < newArraySeries.length; index++) {
                const serie = newArraySeries[index];
                if (newArraySeries.length === 1) {
                    defaultName = serie.SeriesName;
                    defaultcode = serie.Series;
                    nextNumber = serie.NextNumber
                }
            }

            newOrderModel.SerieArray = newArraySeries;
            newOrderModel.SerieName = defaultName;
            newOrderModel.SerieCode = defaultcode;
            newOrderModel.NextFolio = nextNumber;

            if (view === 'productionOrder' && !newOrderModel?.UserSelected?.U_NAME) { // Asignar usuario logueado
                const user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
                if (!newOrderModel.UserSelected) {
                    newOrderModel.UserSelected = {};
                }
                newOrderModel.UserSelected.U_NAME = user?.USER_CODE || '';
                newOrderModel.UserSignature = user?.USERID || '';
            }

        }

        enableSpinner(false)
        await this.setState({
            showDocumentModal: true,
            documentModalAction: 1,
            newOrderModel,
        });

        this.documentCreateModal.restartTabs();
        $('#DocumentCreateModal').modal({ backdrop: 'static', keyboard: false }, 'show');
    };

    selectTable = (view = null, docTypeMiddleware = null) => {
        let name = "";
        let complement = "";
        let docSubType = "";
        let docType = "";
        let name2 = "";
        let complement2 = "";
        let docSubType2 = "";
        let docType2 = "";
        switch (view) {
            case 'quotations':
                name = "OQUT";
                complement = "QUT1";
                docSubType = "--";
                docType = "23";
                break;
            case 'orderSales':
                name = "ORDR";
                complement = "RDR1";
                docSubType = "--";
                docType = "17";
                break;
            case 'deliveries':
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                break;
            case 'invoice':
                name = "OINV";
                complement = "INV1";
                docSubType = "--";
                docType = "13";
                break;
            case 'invoiceAdvance':
                name = "ODPI";
                complement = "DPI1";
                docSubType = "--";
                docType = "203";
                break;
            case 'pendingTimbraDoc':
                name = "PTDS";
                complement = "";
                docSubType = "--";
                docType = "0117";
                break
            case 'return':
                name = "ORDN";
                complement = "RDN1";
                docSubType = "--";
                docType = "16";
                break;
            case 'purchaseReturn':
                name = "ORPD";
                complement = "RPD1";
                docSubType = "--";
                docType = "21";
                break;
            case 'payment':
                name = "ORCT";
                complement = "RCT1";
                docSubType = "--";
                docType = "24";
                break;
            case 'transfers':
                name = "OWTR";
                complement = "WTR1";
                docSubType = "--";
                docType = "67";
                break;
            case 'transfersRequest':
                name = "OWTQ";
                complement = "WTQ1";
                docSubType = "--";
                docType = "1250000001";
                break;
            case 'transfersEntry':
                name = "OIGN";
                complement = "IGN1";
                docSubType = "--";
                docType = "59";
                break;
            case 'transfersOutput':
                name = "OIGE";
                complement = "IGE1";
                docSubType = "--";
                docType = "60";
                break;
            case 'debitNote':
                name = "OINVDN";
                complement = "INV1";
                docSubType = "DN";
                docType = "13";
                break;
            case 'creditNote':
                name = "ORIN";
                complement = "RIN1";
                docSubType = "--";
                docType = "14";
                break;
            case 'PurchaseOrder':
                name = "OPOR";
                complement = "POR1";
                docSubType = "--";
                docType = "22";
                break;
            case 'GoodsReceipt':
                name = "OPDN";
                complement = "PDN1";
                docSubType = "--";
                docType = "20";
                break;

            case 'PurchaseRequest':
                name = "OPRQ";
                complement = "PRQ1";
                docSubType = "--";
                docType = "1470000113";
                break;

            case 'invoiceBorrador':
                name = "ODRF";
                complement = "DRF1";
                docSubType = "--";
                break;
            case 'invoiceAuthorization':
                name = "OWDD";
                complement = "OWDD";
                docSubType = "--";
                break;
            case 'bussinesPartner':
                name = "OCRD";
                complement = "CRD1";
                docSubType = "--";
                break;
            case 'inventoryRevaluation':
                name = "OMRV";
                complement = "MRV1";
                docSubType = "--";
                docType = "162";
                break;
            case 'SalesHelmets':
                name = "OIGN";
                name2 = "ORIN";
                complement = "IGN1";
                complement2 = "RIN1"
                docSubType = "--";
                docSubType2 = "--";
                docType = "59";
                docType2 = "14"
                break;
            case 'ExitHelmets':
                name = "OIGE";
                name2 = "OINVDN";
                complement = "IGE1";
                complement2 = "INV1"
                docSubType = "--";
                docSubType2 = "DN";
                docType = "60";
                docType2 = "13"
                break;
            case 'purchaseInvoice':
                name = "OPCH";
                complement = "PCH1";
                docSubType = "--";
                docType = "18";
                break;
            case 'purchaseCreditNotes':
                name = "ORPC";
                complement = "RPC1";
                docSubType = "--";
                docType = "19";
                break;
            case 'outgoingPayment':
                name = "OVPM";
                complement = "VPM1";
                docSubType = "--";
                docType = "46";
                break;
            case 'invoiceReserve':
                name = "OINV";
                complement = "INV1";
                docSubType = "--";
                docType = "13";
                break;
            case 'middleware':
                if (docTypeMiddleware === '22') {
                    name = "OPOR";
                    complement = "POR1";
                    docSubType = "--";
                    docType = "22";
                } else if (docTypeMiddleware === '18') {
                    name = "OPCH";
                    complement = "PCH1";
                    docSubType = "--";
                    docType = "18";
                }

                break;
            case 'goodsIssue':
                name = "OIGE";
                complement = "IGE1";
                docSubType = "--";
                docType = "60";
                break;
            case 'goodsReceiptProd':
                name = "OIGN";
                complement = "IGN1";
                docSubType = "--";
                docType = "59";
                break;
            //#region CARTA PORTE
            case 'consignmentNote':
                name = "OCPT";
                complement = "CPT1";
                docSubType = "--";
                break;
            case 'citibanamex':
                name = this.state.docFilter;
                complement = this.state.docFilter === 'OPCH' ? "PCH1" : "POR1";
                docSubType = "--";
                break;
            case 'landedCosts':
                name = "OIPF";
                complement = "IPF1";
                docSubType = "--";
                docType = "69";
                break;
            case 'productTree':
                name = "OITT";
                complement = "ITT1";
                docSubType = "--";
                docType = "66";
                break;
            case 'productionOrder':
                name = "OWOR";
                complement = "WOR1";
                docSubType = "--";
                docType = "202";
                break;
            //#endregion
            //#region RESOURCES
            case 'rscMasterData':
                name = "ORSC";
                complement = "";
                docSubType = "--";
                docType = "290";
                break;
            //#endregion
            case 'PurchaseQuotation':
                name = 'OPQT'; // Cotización de compra
                complement = "PQT1";
                docSubType = "--";
                docType = "540000006";
                break;
            default:
                name = "";
                complement = "";
                docSubType = "";
                docType = "13";
        }

        return { name, complement, docSubType, docType, name2, complement2, docSubType2, docType2 }
    };

    sendModelToCreateDocument = async model => {
        const { enableSpinner, view, notificationReducer: { showAlert } } = this.props;
        const { comments } = this.state;
        model.view = view;

        if (view === 'provConfAssistant') {
            // leer contenido de la funcion
            this.documentCreateModal.updateProvConfAssist();
        }
        if ((model.OriginDocumentCreate === 'goodsIssue' || model.OriginDocumentCreate === 'goodsReceiptProd') && await !this.ValidateModelFields(model)) return
        const user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || {};
        const table = this.selectTable(model.OriginDocumentCreate);
        const sendModel = model;
        delete sendModel.SerieArray;
        const data = {
            destino: table.name,
            docSubType: table.docSubType,
            model: sendModel,
            user_Email: user.E_Mail,
            comments,
        };
        enableSpinner(true)
        let response
        if (model.isEdit) {
            response = await apiClient.updateNewDocProd(data);
        } else {
            response = await apiClient.createNewDocProd(data);
        }
        enableSpinner(false)
        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            this.searchDocuments()
            this.setEditMode(false)
            $('#DocumentCreateModal').modal('hide');
            showAlert({ type: 'success', message: response.message + (response?.data?.DocEntry ?? '') || 'CREADO', timeOut: 8000 })
        } else {
            showAlert({ type: 'error', message: response.message || 'OCURRIÓ UN ERROR', timeOut: 8000 })
        }
    }

    ValidateModelFields = (model) => {
        const { notificationReducer: { showAlert } } = this.props
        let flag = true;
        if (model.SerieCode === "" || model.SerieCode === '') {
            showAlert({ type: 'warning', timeOut: 3000, message: "Selecciona una serie valida" });
            flag = false;
        }
        if (model?.OriginDocumentCreate === 'goodsReceiptProd' && model?.DocumentLines?.length && model?.DocumentLines?.some(line => !line.TranType)) {
            showAlert({ type: 'warning', timeOut: 3000, message: "Complete la clase de operación para todas las líneas" });
            flag = false;
        }
        return flag;
    }

    FillCopyToComments = (oldModel, oldView) => {
        if (oldView === 'productionOrder') {
            return oldModel?.Comments ?? '';
        }
        const commentObj = {
            'productionOrder': 'Orden de fabricación'
        }

        return `Documento basado en ${commentObj[oldView]} DocNum: ${oldModel?.DocNum}`;
    }

    CopyToDoc = async (newView) => {
        const { newOrderModel } = this.state
        const oldOrderModel = newOrderModel;
        const oldView = this.props.view;
        await this.createDocument(newView);
        await this.FillModelWithOldData(oldOrderModel, newView, oldView)
    }

    DuplicateDoc = async (newView = '') => {
        if (newView === 'productionOrder') {
            const { newOrderModel } = this.state;
            const oldOrderModel = newOrderModel;
            const oldView = this.props.view;
            await this.createDocument(newView);
            await this.FillModelWithOldData(oldOrderModel, newView, oldView)
        } else { // Validar funcionamiento en caso de duplicar otras vistas diferentes a productionOrder

        }
    }

    FillModelWithOldData = async (oldModel, newView, oldView) => {
        let auxNewOrderModel = null;
        switch (newView) {
            case 'goodsIssue':
                auxNewOrderModel = await this.FillInventoryGenExitsInfo(oldModel);
                break;
            case 'goodsReceiptProd':
                auxNewOrderModel = await this.FillInventoryGenEntries(oldModel);
                break;
            case 'productionOrder':
                auxNewOrderModel = await this.FillProductionOrder(oldModel);
                auxNewOrderModel.ListMaterialCopy = {
                    ProductTreeLines: auxNewOrderModel?.ProductionOrderLines?.map(itm => ({
                        Code: itm.ItemNo,
                        Quantity: itm.BaseQuantity
                    })) ?? []
                };
                break;

            default:
                break;
        }
        auxNewOrderModel.Comments = await this.FillCopyToComments(oldModel, oldView);
        await this.setState({
            newOrderModel: auxNewOrderModel
        })
    }

    FillInventoryGenExitsInfo = (oldModel) => {
        const { newOrderModel } = this.state
        let auxNewOrder = newOrderModel;

        let newLines = [];
        let cont = 0;
        for (let n = 0; n < oldModel.ProductionOrderLines.length; n++) {
            const oldLine = oldModel.ProductionOrderLines[n];

            // if (oldLine.ProductionOrderIssueType === "im_Manual") { // Version 1
            if (oldLine.ProductionOrderIssueType === "im_Manual" && ((Number(oldLine.PlannedQuantity ?? 0) - Number(oldLine.IssuedQuantity ?? 0)) > 0)) { // Version 2
                let modelLine = new InventoryGenExitsLine();
                modelLine.ItemCode = oldLine.ItemNo;
                modelLine.ItemDescription = oldLine.ItemName;
                modelLine.WarehouseCode = oldLine.Warehouse;
                modelLine.BaseType = 202;
                modelLine.BaseLine = oldLine.LineNumber ?? -1;
                modelLine.BaseEntry = oldModel.DocEntry ?? -1;
                modelLine.BaseRef = oldModel.DocNum ?? -1;
                // modelLine.Quantity = Number(oldLine.IssuedQuantity) ?? '';
                modelLine.Quantity = Number(oldLine.PlannedQuantity ?? 0) - Number(oldLine.IssuedQuantity ?? 0);
                // modelLine.Price = 
                modelLine.LineNum = cont;
                cont += 1;
                // series name
                modelLine.ItemType = oldLine?.ItemType ?? 4;
                modelLine.PlannedQty = Number(oldLine?.PlannedQuantity ?? oldLine?.PlannedQty ?? 0);
                modelLine.WhsCode = oldLine?.WhsCode ?? '';
                modelLine.WhsName = oldLine?.WhsName ?? '';
                modelLine.unitMsr = oldLine?.unitMsr ?? '';
                modelLine.OcrCode = oldLine?.OcrCode ?? '';
                modelLine.OcrCode2 = oldLine?.OcrCode2 ?? '';
                modelLine.OcrCode3 = oldLine?.OcrCode3 ?? '';
                modelLine.OcrCode4 = oldLine?.OcrCode4 ?? '';
                modelLine.OcrCode5 = oldLine?.OcrCode5 ?? '';
                newLines.push(modelLine);
            }
        }
        auxNewOrder.DocumentLines = newLines;
        auxNewOrder.Reference2 = '';
        return auxNewOrder;
    }

    FillInventoryGenEntries = (oldModel) => {
        const { newOrderModel, wareHouses } = this.state
        let auxNewOrder = newOrderModel;
        let cont = 0;
        let modelLine = new InventoryGenEntriesLine();
        modelLine.ItemCode = oldModel.ItemNo;
        modelLine.ItemDescription = oldModel.ItemName;
        modelLine.WarehouseCode = oldModel.Warehouse;
        modelLine.BaseType = 202;
        modelLine.BaseLine = null;
        modelLine.BaseEntry = oldModel.DocEntry ?? -1;
        modelLine.BaseRef = oldModel.DocNum ?? -1;
        // modelLine.Quantity = Number(oldModel.PlannedQuantity) ?? ''; // Version 1
        modelLine.Quantity = (Number(oldModel.PlannedQuantity ?? 0) - Number(oldModel?.totalReceived ?? 0)) ?? 0; // Version 2
        modelLine.LineNum = cont;
        modelLine.TranType = oldModel?.TranType ?? 'C';
        modelLine.WhsCode = oldModel?.Warehouse ?? '';
        modelLine.WhsName = oldModel?.WhsName ?? '';
        modelLine.unitMsr = oldModel?.Uom ?? '';
        modelLine.OcrCode = oldModel?.OcrCode ?? '';
        modelLine.OcrCode2 = oldModel?.OcrCode2 ?? '';
        modelLine.OcrCode3 = oldModel?.OcrCode3 ?? '';
        modelLine.OcrCode4 = oldModel?.OcrCode4 ?? '';
        modelLine.OcrCode5 = oldModel?.OcrCode5 ?? '';
        //#region DIMENSIONS
        if (Modules.CostCenter && modelLine.WhsCode) {
            const warehouse = wareHouses?.find(whs => whs.WhsCode === modelLine.WhsCode);
            modelLine.OcrCode2 = warehouse?.U_LLG_DIME2 || ''; // Determinado desde el almacén
            modelLine.OcrCode3 = warehouse?.U_LLG_DIME3 || ''; // Determinado desde el almacén

            modelLine.Dimension2 = modelLine.OcrCode2 ? true : false;
            modelLine.Dimension3 = modelLine.OcrCode3 ? true : false;
        }
        //#endregion DIMENSIONS
        modelLine.PlannedQty = Number(oldModel?.PlannedQuantity ?? 0) > 0 ? Number(oldModel?.PlannedQuantity) : '';

        auxNewOrder.DocumentLines = [modelLine];
        auxNewOrder.Reference2 = '';

        return auxNewOrder;

    }

    FillProductionOrder = (oldModel) => { // Utilizado en duplicado de orden de fabricación
        const { _user, wareHouses = [] } = this.state;
        oldModel.isEdit = false; // Al enviar al back sea create no update
        //#region HEADER
        oldModel.PostingDate = moment(new Date()).format('YYYY-MM-DD');
        oldModel.StartDate = moment(new Date()).format('YYYY-MM-DD');
        oldModel.DueDate = moment(new Date()).format('YYYY-MM-DD');
        oldModel.UserSelected = {};
        oldModel.UserSelected.U_NAME = _user?.USER_CODE || ''; // Usuario logueado
        oldModel.UserSignature = _user?.USERID || ""; // Aunque se mande otro SL asigna manager
        oldModel.ProductionOrderStatus = 'P';
        oldModel.CurrentStatus = 'P';
        oldModel.OnlyView = false;
        oldModel.FlagCreateGoodIssue = false;
        oldModel.FlagCreateGoodsReceiptProd = false;
        oldModel.RelatedDocs = [];
        oldModel.DocNum = '';
        oldModel.DocEntry = '';
        oldModel.SerieCode = '';
        oldModel.SerieName = '';
        oldModel.NextFolio = '';
        //#region CUFD
        oldModel.U_RS_CANT = 0;
        //#endregion CUFD
        //#endregion HEADER

        //#region Costos
        oldModel.CostoComponenteArticuloReal = '';
        oldModel.CostoComponenteRecursoReal = '';
        oldModel.CostoAdicionalReal = '';
        oldModel.CostoComponenteArticuloReal = '';
        oldModel.CosteRealSubproductos = '';
        oldModel.DesviacionTotal = '';
        oldModel.JournalRemarks = '';
        //#endregion Costos

        //#region Cantidades
        oldModel.CompletedQuantity = 0;
        oldModel.RejectedQuantity = 0;
        //#endregion Cantidades

        //#region Fechas
        oldModel.ClosingDate = '';
        oldModel.Vencido = '';
        //#endregion Fechas

        //#region Tiempos planificados
        oldModel.TiempoEjecucionTotal = '';
        oldModel.TiempoAdicionalTotal = '';
        oldModel.TiempoTotal = '';
        //#endregion Tiempos planificados

        //#region Default Warehouse Determination
        const U_FMB_WHS_TYPE = Number(_user?.Branch?.AccountDefault?.[0]?.U_FMB_WHS_TYPE ?? 0);
        const availableWhs = _user?.Branch?.AvailableWhs ?? [];
        const availableSet = new Set(availableWhs?.map(a => a.WhsCode));
        const whsMap = new Map((wareHouses ?? [])?.map(w => [w.WhsCode, w]));

        if (oldModel?.Warehouse) { // Validar almacén cabecera que sea de producto terminado
            const allowedTypes = [
                '008', // PT
            ]
            const whs = whsMap.get(oldModel?.Warehouse);
            const baseCondition = whs.Inactive === 'N' && allowedTypes?.includes(whs?.U_RS_TipoAlmacen ?? '');

            const warehouseValid =
                baseCondition &&
                (
                    U_FMB_WHS_TYPE === 3 || // Maestra ve todos los PT
                    availableSet.has(whs.WhsCode) // NO maestra ve los PT configurados
                );

            oldModel.Warehouse = warehouseValid ? whs.WhsCode : '';

            //#region Determinar almacén cabecera si no existe
            if (!oldModel.Warehouse) { // Si no existe revisar cual pudiera ser el default
                const whsOptions = wareHouses
                    ? wareHouses?.filter(whs => {
                        const baseCondition =
                            whs.Inactive === 'N' // No sea inactivo
                            && whs?.U_RS_TipoAlmacen === '008'; // Solo Producto terminado

                        if (!baseCondition) return false;

                        if (Number(U_FMB_WHS_TYPE) === 3) return true; // Si es maestra no validar los almacenes configurados
                        return availableWhs?.some(a => a.WhsCode === whs.WhsCode); // Si NO es maestra validar que exista en los almacenes cofigurados
                    })?.map(whs => whs.WhsCode)
                    : [];

                if (whsOptions?.length === 1) {
                    oldModel.Warehouse = whsOptions?.[0] ?? '';
                } else {
                    oldModel.Warehouse = '';
                }
            }
            //#endregion Determinar almacén cabecera si no existe
        }
        //#endregion Default Warehouse Determination

        //#region LINES
        for (const line of oldModel?.ProductionOrderLines) {
            line.IssuedQuantity = 0;
            line.IsNew = true;
            // line.ProductionOrderIssueType = 'im_Backflush'; // Default nacen en notificación}

            //#region Default Warehouse Determination
            const allowedTypes =
                (Number(line?.ItemType ?? 4) === 4 ||
                    Number(line?.ItemType ?? 4) === 290) ?
                    [
                        '003', // CILINDROS
                        '004', // INSUMOS
                        '099', // GLP
                        '008', // PT
                    ]
                    : null;
            const whs = whsMap.get(line.Warehouse);

            if (!whs) {
                line.Warehouse = '';
            } else {
                const baseCondition =
                    whs.Inactive === 'N' &&
                    (
                        !allowedTypes ||
                        allowedTypes?.includes(whs?.U_RS_TipoAlmacen ?? '')
                    );

                const warehouseValid =
                    baseCondition &&
                    (
                        U_FMB_WHS_TYPE === 3 ||
                        availableSet.has(whs.WhsCode)
                    );

                //#region Validar que pertenezca al almacén cabecera
                const headerWhs = String(oldModel.Warehouse ?? '');
                const lineWhs = String(whs.WhsCode ?? '');

                const first3Match = headerWhs?.substring(0, 3) === lineWhs?.substring(0, 3);
                const first2Match = headerWhs?.substring(0, 2) === lineWhs?.substring(0, 2);

                const prefixValid = headerWhs
                    ? (first3Match || first2Match)
                    : false;

                line.Warehouse = (warehouseValid && prefixValid)
                    ? whs.WhsCode
                    : '';
                //#endregion Validar que pertenezca al almacén cabecera
            }
            //#endregion Default Warehouse Determination
        }
        //#endregion LINES

        return oldModel;
    }


    render() {
        const { docNumSearch, newOrderModel, writeAccess, documentModalAction, showDocumentModal, tableSearch } = this.state;
        const { notificationReducer: { showAlert }, enableSpinner, view, projects } = this.props;

        return (
            <div>
                <ContinueModal
                    refreshContinue={this.refreshContinue}
                    newOrderModel={newOrderModel}
                />

                {showDocumentModal &&
                    <NewDocCreateModal
                        view={view}
                        newOrderModel={newOrderModel}
                        showAlert={showAlert}
                        enableSpinner={enableSpinner}
                        refreshModel={this.refreshModel}
                        createDocument={this.sendModelContinue}
                        action={documentModalAction}
                        writeAccess={writeAccess}
                        CloseDocumentModal={this.CloseDocumentModal}
                        wareHouses={this.state.wareHouses}
                        listPrice={this.state.listPrice}
                        ref={(ref) => this.documentCreateModal = ref}
                        sendModelToCreateDocument={this.sendModelToCreateDocument}
                        openDocumentDetails={this.OpenDocumentDetails}
                        listProjects={this.state.listProjects}
                        copyTo={this.state.copyTo}
                        CopyToDoc={this.CopyToDoc}
                        editMode={this.state.editMode}
                        setEditMode={this.setEditMode}
                        selectTable={this.selectTable}
                        searchDocuments={this.searchDocuments}
                        projects={projects}
                        DuplicateDoc={this.DuplicateDoc}
                    />
                }

                <div className="form-inline" style={{ important: true, paddingTop: 10, paddingBottom: 0 }}>
                    {view !== "rscMasterData" &&
                        <div className="form-group mb-2 mr-1">
                            <label className="Desde"><strong>Desde:&nbsp;&nbsp;</strong></label>
                            <input id="startDate"
                                disabled={this.state.suggestionDocs}
                                className="form-control btn-outline-secondary listSerie " type="date"
                                placeholder="Fecha min" autoComplete="off"
                                max='9999-12-31'
                                onKeyDown={event => event.keyCode === 13 && this.searchDocuments()} />
                        </div>
                    }
                    {view !== "rscMasterData" &&
                        <div className="form-group mb-2">
                            <label className="Hasta"><strong> &nbsp;&nbsp;Hasta:&nbsp;&nbsp;</strong></label>
                            <input id="endingDate"
                                disabled={this.state.suggestionDocs}
                                className="form-control btn-outline-secondary listSerie " type="date"
                                placeholder="Fecha min" autoComplete="off"
                                max='9999-12-31'
                                onKeyDown={event => event.keyCode === 13 && this.searchDocuments()} />
                        </div>
                    }

                    {view === "provConfAssistant" &&
                        <div className="form-group mb-2 form-responsive">
                            &nbsp;
                            <label><strong> &nbsp;&nbsp;Documento:&nbsp;&nbsp;</strong></label>
                            <select
                                type="text"
                                className="btn-outline-secondary input-sm input-responsive"
                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40, maxWidth: 190 }}
                                onChange={(e) => this.searchByTable(e)}
                                value={tableSearch}>
                                {selectDocValues.map((type, index) => {
                                    return (<option key={index} value={type.Value}>{type.Tittle}</option>)
                                })}
                            </select>
                        </div>
                    }

                    {view !== "rscMasterData" &&
                        <div className="form-group mb-2">
                            &nbsp;
                            <label className="label-responsive mb-0">
                                <strong>
                                    <span className="d-none d-xl-inline">&nbsp;&nbsp;Búsqueda del Documento:&nbsp;&nbsp;</span>
                                    <span className="d-inline d-xl-none">&nbsp;Búsq. Doc:&nbsp;</span>
                                </strong>
                            </label>
                            <input type="text" className="btn-outline-secondary input-sm input-responsive"
                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40, maxWidth: 110 }}
                                id="txtDocNum"
                                placeholder="DocNum"
                                onKeyDown={event => event.keyCode === 13 && this.searchDocuments()}
                                onChange={(event) => this.searchByDocNum(event)}
                                value={docNumSearch || ''}
                            />
                        </div>
                    }

                    &nbsp;&nbsp;

                    <button className="btn btn-active" data-toggle="tooltip" data-placement="top" title="Buscar" onClick={this.searchDocuments}>
                        <i className="fas fa-search" />
                    </button>
                </div>

                {this.renderTableActions()}

                <br />
                <div className="w-100 table-scroll">
                    {this.renderTable()}
                </div>
                <br />

                <div className="d-flex flex-wrap justify-content-end align-items-center">
                    <div className="form-group mb-2">
                        <label htmlFor="colFormLabelSm" className="col col-form-label col-form-label-sm text-right registros" style={{ width: 195 }}>
                            Registros por página:
                        </label>
                    </div>
                    <div className="form-group mb-2">
                        <select
                            className="col col-form-label col-form-label-sm text-right"
                            style={{ width: 80 }}
                            id='changePaginateSelect'
                            onChange={() => this.changePaging}>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>&nbsp;&nbsp;
                    </div>
                    <div className="form-group mb-2">
                        <label htmlFor="colFormLabelSm" id="tableInfo"
                            className="col-form-label col-form-label-sm">
                        </label>
                    </div>
                    <div className="d-flex align-items-center mb-2 flex-nowrap">
                        <button className="btn btn-link btn-sm " style={{ color: "black" }} data-toggle="tooltip"
                            data-placement="top"
                            title="Primera" onClick={() => this.changePage('first')}
                        >
                            <i className="fas fa-chevron-left btn-first" />
                        </button>
                        <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                            data-placement="top"
                            title="Anterior" onClick={() => this.changePage('previous')}
                        >
                            <i className="fas fa-chevron-left" />
                        </button>
                        <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                            data-placement="top"
                            title="Siguiente" onClick={() => this.changePage('next')}
                        >
                            <i className="fas fa-chevron-right" />
                        </button>
                        <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                            data-placement="top"
                            title="Última" onClick={() => this.changePage('last')}
                        >
                            <i className="fas fa-chevron-right btn-last" />
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        notificationReducer: store.NotificationReducer,
        renderReducer: store.RenderReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
        setPrintToDocumentsModal: value => dispatch({ type: DISPATCH_ID.RENDER_PRINT_TO_DOCUMENTS_MODAL, value }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewDocTable);